<sbd-account-portal-frontend-purchase-steps-wrapper
  class="w-full h-full"
  [step]="step"
  [selectedQR]="selectedQR"
  [showCloseButton]="showCloseButton"
  (closeDrawerEvent)="onCloseDrawer()"
  (moveBackEvent)="onMoveBack()"
  (moveToNextStepEvent)="onMoveToNextStep()">
  <ng-container [ngSwitch]="step">
    <!--List View-->
    <ng-container *ngSwitchCase="1">
      <sbd-account-portal-frontend-open-quote-request-list-view
        [selectedQR]="selectedQR"
        [queuedQR]="queuedQR"
        [subtotal]="subtotal"
        (updatedOpenQREvent)="onUpdateSelectedQuoteOption($event)">
      </sbd-account-portal-frontend-open-quote-request-list-view>
    </ng-container>

    <!--Delivery Details View-->
    <ng-container *ngSwitchCase="2">
      <sbd-account-portal-frontend-delivery-details
        [selectedQR]="selectedQR"
        [queuedQR]="queuedQR"
        [subtotal]="subtotal"
        [activeOpenedQR]="activeOpenedQR"
        (getShippingMethodValueEvent)="onGetShippingMethodValue($event)"
        (updatedOpenQREvent)="onUpdateSelectedQuoteOption($event)">
      </sbd-account-portal-frontend-delivery-details>
    </ng-container>

    <!--Payment Details View-->
    <ng-container *ngSwitchCase="3">
      <sbd-account-portal-frontend-payment-details
        [selectedQR]="selectedQR"
        [queuedQR]="queuedQR"
        [subtotal]="subtotal"
        [checkoutForm]="checkoutForm"
      >
      </sbd-account-portal-frontend-payment-details>
    </ng-container>

    <!--Checkout Page View-->
    <ng-container *ngSwitchCase="4">
      <sbd-account-portal-frontend-checkout-page
        [selectedQR]="selectedQR"
        [queuedQR]="queuedQR"
        [subtotal]="subtotal"
        [checkoutForm]="checkoutForm"
        (moveBackEvent)="onMoveBack()"
        (closeDrawerEvent)="onCloseDrawer()"
        (updatedOpenQREvent)="onUpdateSelectedQuoteOption($event)">
      </sbd-account-portal-frontend-checkout-page>
    </ng-container>

    <!--Confirmation Page View-->
    <ng-container *ngSwitchCase="5">
      <sbd-account-portal-frontend-purchase-confirmation-page-view
        [selectedQR]="selectedQR"
        [queuedQR]="queuedQR"
        [subtotal]="subtotal"
        [checkoutForm]="checkoutForm"
        [loggedInAccountUser]="loggedInAccountUser"
        [isPurchased]="isPurchased"
        [recentlyPurchasedCount]="recentlyPurchasedCount"
        (moveBackEvent)="onMoveBack()"
        (closeDrawerEvent)="onCloseDrawer()">
      </sbd-account-portal-frontend-purchase-confirmation-page-view>
    </ng-container>
  </ng-container>
</sbd-account-portal-frontend-purchase-steps-wrapper>
